var cov_2443n0o380 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/item.tsx",
      hash = "dec621a634fdd80b9c3f70b6eb6d9a1695c1210e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "2": {
        start: {
          line: 16,
          column: 57
        },
        end: {
          line: 16,
          column: 67
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "4": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 58
        }
      },
      "5": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 73
        }
      },
      "6": {
        start: {
          line: 20,
          column: 56
        },
        end: {
          line: 20,
          column: 71
        }
      },
      "7": {
        start: {
          line: 25,
          column: 73
        },
        end: {
          line: 25,
          column: 83
        }
      },
      "8": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "9": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "10": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 114
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 49
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 32
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 50
          },
          end: {
            line: 20,
            column: 51
          }
        },
        loc: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 71
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 17
          }
        },
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 46,
            column: 21
          }
        },
        line: 42
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 43,
            column: 5
          },
          end: {
            line: 43,
            column: 6
          }
        },
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 114
          }
        },
        line: 44
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 55
          },
          end: {
            line: 27,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 55
          },
          end: {
            line: 27,
            column: 63
          }
        }, {
          start: {
            line: 27,
            column: 67
          },
          end: {
            line: 27,
            column: 82
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/item.tsx",
    _this2 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Checkbox from '../Checkbox';
import { PureComponent } from '../component';
import { transferClass } from './styles';
import Context from './context';

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    cov_2443n0o380.f[0]++;
    cov_2443n0o380.s[0]++;
    _this = _super.call(this, props);
    cov_2443n0o380.s[1]++;
    _this.check = _this.check.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "check",
    value: function check(c) {
      cov_2443n0o380.f[1]++;

      var _ref = (cov_2443n0o380.s[2]++, this.props),
          index = _ref.index,
          selecteds = _ref.selecteds,
          checkKey = _ref.checkKey,
          setSelecteds = _ref.setSelecteds;

      cov_2443n0o380.s[3]++;

      if (c) {
        cov_2443n0o380.b[0][0]++;
        cov_2443n0o380.s[4]++;
        setSelecteds(index, [].concat(_toConsumableArray(selecteds[index]), [checkKey]));
      } else {
        cov_2443n0o380.b[0][1]++;
        cov_2443n0o380.s[5]++;
        setSelecteds(index, selecteds[index].filter(function (ch) {
          cov_2443n0o380.f[2]++;
          cov_2443n0o380.s[6]++;
          return ch !== checkKey;
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_2443n0o380.f[3]++;

      var _ref2 = (cov_2443n0o380.s[7]++, this.props),
          content = _ref2.content,
          selecteds = _ref2.selecteds,
          checkKey = _ref2.checkKey,
          index = _ref2.index,
          disabled = _ref2.disabled,
          itemClass = _ref2.itemClass;

      cov_2443n0o380.s[8]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(transferClass('item', (cov_2443n0o380.b[1][0]++, disabled) && (cov_2443n0o380.b[1][1]++, 'item-disabled')), itemClass),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Checkbox, {
          className: transferClass('item-check'),
          onChange: this.check,
          disabled: disabled,
          checked: selecteds[index].indexOf(checkKey) > -1,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 9
          }
        }, content))
      );
    }
  }]);

  return Item;
}(PureComponent);

export default (function (prop) {
  cov_2443n0o380.f[4]++;
  cov_2443n0o380.s[9]++;
  return (
    /*#__PURE__*/
    React.createElement(Context.Consumer, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 3
      }
    }, function (value) {
      cov_2443n0o380.f[5]++;
      cov_2443n0o380.s[10]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, Object.assign({}, prop, {
          selecteds: value.selecteds,
          setSelecteds: value.setSelecteds,
          itemClass: value.itemClass,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 44,
            columnNumber: 7
          }
        }))
      );
    })
  );
});